import { isFeatureEnabled } from '@lumapps/features';

/** New space navigation FF */
export const isSpaceNavigationV2Enabled = isFeatureEnabled('space-navigation-rework');
